import { Stack, styled } from '@mui/material';
import { StyledSummaryTableRowProps } from './types';

export const StyledTableContainer = styled(Stack)`
  margin-top: 16px;
  margin-left: auto;
`;

export const StyledSummaryTableRow = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'addBorderTop' && prop !== 'addPaddingTop',
})<StyledSummaryTableRowProps>`
  flex-direction: row;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  border-top: ${({ addBorderTop }) => (addBorderTop ? '1px solid #C0C7CA' : 'none')};
  padding-top: ${({ addPaddingTop }) => (addPaddingTop ? '16px' : '0')};

`;
